<template>
    <div>
        <!--新增-->
        <div class="tool_head">
          <el-button type="success" icon="el-icon-circle-plus-outline" @click="add=true" round>添加</el-button>
        </div>
        <DxDataGrid :data-source="info"
                    :show-borders="false"
                    :focused-row-enabled="true"
                    :row-alternation-enabled="true"
                    :hover-state-enabled="true"
                    key-expr="id"
                    :selection="{ mode: 'single' }"
                    @selection-changed="selectionChanged">
            <!--加载框-->
            <DxColumn data-field="id" caption="序号" data-type="string" />
            <DxColumn data-field="messagePublicName" caption="营销名称" data-type="string" />
            <DxColumn data-field="content" caption="模版内容" data-type="string" />
            <DxColumn data-field="sendDate" caption="推送日期" data-type="date" format="yyyy-MM-dd"/>
            <dx-column data-field="fromUserName" caption="操作"
                       cell-template="butTemplate" :allow-sorting="false"/>
            <dx-filter-row :visible="true" />
            <DxHeaderFilter :visible="true" :allow-search="true"/>
            <dx-paging :page-size="10" />
            <dx-pager  :allowed-page-sizes="[10, 20, 50, 100,200]" :show-page-size-selector="true"
                       :show-info="true" :show-borders="true" :show-navigation-buttons="true"/>


            <template #butTemplate="{ data }">
                <div>
                    <DxButton   type="success" styling-mode="contained"  :use-submit-behavior="true"  icon="sortup"
                                @click="sort('0')"/>&nbsp;
                    <DxButton   type="success" styling-mode="contained"  :use-submit-behavior="true"  icon="sortdown"
                                @click="sort('1')"/>
                </div>
            </template>
        </DxDataGrid>


        <DxPopup :width="1000" :height="800" :show-title="true"  :drag-enabled="false" :visible="add" title="添加">
            <DxScrollView width="100%" height="100%" direction="both">
                <ContentPageAdd @close="add=false" @refresh="getList"></ContentPageAdd>
            </DxScrollView>
        </DxPopup>


    </div>
</template>
<script>

    import {DxDataGrid,DxColumn,DxButton as DxTextBoxButton } from 'devextreme-vue/data-grid';
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import ContentPageAdd from "./ContentPageAdd";
    export default {
        /*营销列表*/
        name: "marketingList",
        components: {
            DxScrollView,
            DxDataGrid,
            DxColumn,
            ContentPageAdd
        },
        data(){
            return{
                add:false,
                type:"list",
                info:[],
                selectedItemKeys: '',
                selectionChanged: (data) => {
                    this.selectedItemKeys = data.selectedRowKeys[0];
                },
            }
        },
        created() {
            this.getList()
        },
        computed: {

        },
        methods:{
            getList(){
                this.$http.ContentList(null).then(res => {
                    if(res.status == "success"){
                        this.info=res.data
                    }

                })
            },
            sort(e){
                setTimeout(() => {
                    this.$http.ContentSort({id:this.selectedItemKeys,type:e}).then(res => {
                        if(res.status == "success"){
                            this.getList()
                            this.$notify({type:'success',message:res.msg, position: "top center",width: 1, });
                        }else{
                            this.$notify({type:'error',message:res.msg, position: "top center",width: 1, });
                        }

                    })
                }, 100)
            }

        }
    }
</script>

<style scoped>

</style>